import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ApproveCommissionRequestDto,
  ApproveCommissionResponseDto,
  ReadCommissionsRequestDto,
  ReadCommissionsResponseDto,
  RejectCommissionRequestDto,
  RejectCommissionResponseDto,
  UpdateCommissionRequestDto,
  UpdateCommissionResponseDto,
} from '@sparling/financial-common'

export const {
  request: getCommissionsRequest,
  success: getCommissionsSuccess,
  failure: getCommissionsFailure,
} = createAsyncAction('GET_COMMISSIONS_REQUEST', 'GET_COMMISSIONS_SUCCESS', 'GET_COMMISSIONS_FAILURE')<
  ReadCommissionsRequestDto,
  ReadCommissionsResponseDto,
  Error
>()

export const openApproveCommissionsModal = createAction('OPEN_APPROVE_COMMISSIONS_MODAL')<{
  open: boolean
  ids: number[] | []
}>()

export const openAdjustCommissionsModal = createAction('OPEN_ADJUST_COMMISSIONS_MODAL')<{
  open: boolean
  ids: { [key: number]: number }
}>()

export const setAdjustCommissions = createAction('SET_ADJUST_COMMISSIONS')<{
  percentage: number | null
  amount: number | null
}>()

export const openAdjustConfirmCommissionsModal = createAction('OPEN_ADJUST_CONFIRM_COMMISSIONS_MODAL')<{
  open: boolean
}>()

export const openRejectCommissionsModal = createAction('OPEN_REJECT_COMMISSIONS_MODAL')<{
  open: boolean
  ids: number[] | []
}>()

export const {
  request: approveCommissionsRequest,
  success: approveCommissionsSuccess,
  failure: approveCommissionsFailure,
} = createAsyncAction('APPROVE_COMMISSIONS_REQUEST', 'APPROVE_COMMISSIONS_SUCCESS', 'APPROVE_COMMISSIONS_FAILURE')<
  ApproveCommissionRequestDto,
  ApproveCommissionResponseDto,
  Error
>()

export const {
  request: updateCommissionsRequest,
  success: updateCommissionsSuccess,
  failure: updateCommissionsFailure,
} = createAsyncAction('UPDATE_COMMISSIONS_REQUEST', 'UPDATE_COMMISSIONS_SUCCESS', 'UPDATE_COMMISSIONS_FAILURE')<
  UpdateCommissionRequestDto,
  UpdateCommissionResponseDto,
  Error
>()

export const {
  request: rejectCommissionsRequest,
  success: rejectCommissionsSuccess,
  failure: rejectCommissionsFailure,
} = createAsyncAction('REJECT_COMMISSIONS_REQUEST', 'REJECT_COMMISSIONS_SUCCESS', 'REJECT_COMMISSIONS_FAILURE')<
  RejectCommissionRequestDto,
  RejectCommissionResponseDto,
  Error
>()
export const resetCommissionsFilters = createAction('RESET_COMMISSIONS_FILTERS')<undefined>()
